<template>
  <a-pagination class="ant-pagination" v-bind="$attrs">
    <template v-for="(_, name) in $slots" #[name]="slotProps">
      <slot :name="name" v-bind="slotProps || {}"></slot>
    </template>
  </a-pagination>
</template>

<script setup lang="ts">
defineOptions({
  name: 'AntPagination',
  inheritAttrs: false
})
</script>

<style lang="less" scoped>
.ant-pagination {
  margin-top: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
